// // src/components/page/ar-space/ArSpaceList.tsx
// 'use client';

// import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

// // components
// import InfiniteListWithFetch from '@/components/ui/list/InfiniteListWithFetch';
// import Skeleton from '@/components/ui/skeleton/Skeleton';
// import ArScanModal from '@/components/ui/modal/ArScanModal';
// import MapModal from '@/components/ui/modal/MapModal';
// import ArSpaceCard from '@/components/page/ar-space/ArSpaceCard';
// import { EmptyState, EMPTY, buildEmptyState } from '@/components/ui/emptyState';

// // data
// import type { ArSpace, ArType, ArSpaceGroup, OrderBy } from '@/types/arSpace';
// import { ArSpaceService } from '@/libs/services/arSpace';

// import ArSpaceOutlineIcon from '@/components/icons/ArSpaceOutlineIcon';

// // ✅ 共用定位快取工具
// import {
//   readCachedPosition,
//   writeCachedPosition,
//   getCurrentPositionSafe,
//   type LatLng as GeoLatLng,
// } from '@/libs/location/geoCache';

// // ✅ 後端文件：一頁 20 筆（前端 pageSize 也用 20 最穩）
// const PAGE_SIZE = 20;

// type FilterKind = 'kol' | 'store';
// type TabKind = 'all' | ArType;
// type LatLng = { lat: number; lng: number };
// type ResetKind = 'keyword' | 'tab' | 'order' | 'group' | 'other';

// type LocationStatus = 'idle' | 'pending' | 'ready' | 'denied' | 'unavailable' | 'error';

// const GEO_CACHE_KEY = 'arspace_user_pos_v1';
// const GEO_CACHE_TTL = 30 * 60 * 1000; // 30 min

// type ArSpaceExtended = ArSpace & {
//   ar_type?: ArType | string;
//   store_id?: number | string;
//   storeId?: number | string;
//   owner_open_id?: string;
//   ownerOpenId?: string;
// };

// export type ArSpaceListFilters = {
//   tab: TabKind;
//   keyword: string;
//   orderBy: OrderBy;
//   groupId: string;
// };

// type Props = {
//   filterKind?: FilterKind;
//   filterId?: number | string;
//   listClassName?: string;

//   filters?: Partial<ArSpaceListFilters>;
//   onFiltersChange?: (next: ArSpaceListFilters) => void;

//   enableGroups?: boolean;
//   groups?: ArSpaceGroup[];
// };

// const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// function resolveArTypeParam(filterKind: FilterKind | undefined, tab: TabKind): '' | ArType {
//   if (filterKind === 'store') return 'branch';
//   if (filterKind === 'kol') return 'ar_space';
//   return tab === 'branch' ? 'branch' : tab === 'ar_space' ? 'ar_space' : '';
// }

// function applyOwnerOrStoreFilter(
//   list: ArSpaceExtended[],
//   filterKind: FilterKind | undefined,
//   filterId: number | string | undefined
// ): ArSpaceExtended[] {
//   if (!filterKind || filterId == null) return list;

//   if (filterKind === 'store') {
//     const targetStr = String(filterId);
//     const targetNum = Number(filterId);
//     return list.filter((item) => {
//       const raw = item.store_id;
//       const norm = item.storeId;
//       return (
//         (raw != null && String(raw) === targetStr) || (norm != null && Number(norm) === targetNum)
//       );
//     });
//   }

//   if (filterKind === 'kol') {
//     const target = String(filterId);
//     return list.filter((item) => {
//       const raw = item.owner_open_id;
//       const norm = item.ownerOpenId;
//       return (raw != null && String(raw) === target) || (norm != null && String(norm) === target);
//     });
//   }

//   return list;
// }

// function applyArTypeFilter(
//   list: ArSpaceExtended[],
//   filterKind: FilterKind | undefined,
//   tab: TabKind
// ): ArSpaceExtended[] {
//   if (filterKind === 'store') return list.filter((i) => i.ar_type === 'branch');
//   if (filterKind === 'kol') return list.filter((i) => i.ar_type === 'ar_space');
//   if (tab !== 'all') return list.filter((i) => i.ar_type === tab);
//   return list;
// }

// function applyGroupFilter(
//   list: ArSpaceExtended[],
//   groupId: string,
//   arspaceGroups: ArSpaceGroup[]
// ): ArSpaceExtended[] {
//   if (groupId === 'all') return list;

//   const selectedGroup = arspaceGroups.find((g) => String(g.id) === groupId);
//   if (!selectedGroup || selectedGroup.data.length === 0) return list;

//   const allowedStoreIds = new Set<number>(selectedGroup.data);

//   return list.filter((item) => {
//     const storeId = item.store_id;
//     if (storeId == null) return false;
//     const num = typeof storeId === 'number' ? storeId : Number(storeId);
//     if (Number.isNaN(num)) return false;
//     return allowedStoreIds.has(num);
//   });
// }

// function parseLatLng(latitude?: string, longitude?: string): LatLng | null {
//   if (!latitude || !longitude) return null;
//   const lat = Number(latitude);
//   const lng = Number(longitude);
//   if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
//   if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
//   return { lat, lng };
// }

// function haversineMeters(a: LatLng, b: LatLng): number {
//   const R = 6371000;
//   const toRad = (deg: number) => (deg * Math.PI) / 180;

//   const dLat = toRad(b.lat - a.lat);
//   const dLng = toRad(b.lng - a.lng);

//   const lat1 = toRad(a.lat);
//   const lat2 = toRad(b.lat);

//   const sinDLat = Math.sin(dLat / 2);
//   const sinDLng = Math.sin(dLng / 2);

//   const h = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * (sinDLng * sinDLng);
//   return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
// }

// function getDistanceMeters(user: LatLng, item: ArSpaceExtended): number | null {
//   const pos = parseLatLng(item.latitude, item.longitude);
//   if (!pos) return null;
//   return haversineMeters(user, pos);
// }

// function toLatLng(p: GeoLatLng | null): LatLng | null {
//   if (!p) return null;
//   return { lat: p.lat, lng: p.lng };
// }

// const ArSpaceList: React.FC<Props> = ({
//   filterKind,
//   filterId,
//   listClassName,
//   filters,
//   enableGroups = true,
//   groups,
// }) => {
//   const tab: TabKind = filters?.tab ?? 'all';
//   const keyword: string = filters?.keyword ?? '';
//   const orderBy: OrderBy = filters?.orderBy ?? 'letime';
//   const groupId: string = filters?.groupId ?? 'all';

//   const [resetKind, setResetKind] = useState<ResetKind>('other');

//   // debounce keyword（只影響 fetch / highlight）
//   const [debouncedKeyword, setDebouncedKeyword] = useState('');
//   const debouncedKeywordRef = useRef<string>('');
//   useEffect(() => {
//     const next = keyword.trim();
//     const timer = window.setTimeout(() => {
//       if (debouncedKeywordRef.current === next) return;
//       debouncedKeywordRef.current = next;
//       setDebouncedKeyword(next);
//       setResetKind('keyword');
//     }, 350);
//     return () => window.clearTimeout(timer);
//   }, [keyword]);

//   const highlightText = useCallback(
//     (text: string): React.ReactNode => {
//       if (!debouncedKeyword) return text;
//       const safe = escapeRegExp(debouncedKeyword);
//       const parts = text.split(new RegExp(`(${safe})`, 'gi'));
//       return parts.map((part, i) =>
//         part.toLowerCase() === debouncedKeyword.toLowerCase() ? (
//           <mark key={i} className="fw-bold" style={{ backgroundColor: '#fff2f2' }}>
//             {part}
//           </mark>
//         ) : (
//           part
//         )
//       );
//     },
//     [debouncedKeyword]
//   );

//   // =========================
//   // ✅ distance：定位（含快取）
//   // =========================
//   const [userPos, setUserPos] = useState<LatLng | null>(() => {
//     const cached = toLatLng(
//       readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//     );
//     return cached;
//   });
//   const [locStatus, setLocStatus] = useState<LocationStatus>(() => (userPos ? 'ready' : 'idle'));
//   const [distanceReadyToken, setDistanceReadyToken] = useState(0);

//   const locRequestIdRef = useRef(0);

//   const startLocationRequest = useCallback(() => {
//     // 先用快取救回
//     const cached = toLatLng(
//       readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//     );
//     if (!userPos && cached) {
//       setUserPos(cached);
//       setLocStatus('ready');
//       setResetKind('order');
//       setDistanceReadyToken((v) => v + 1);
//       return;
//     }

//     if (userPos) {
//       setLocStatus('ready');
//       return;
//     }

//     if (locStatus === 'pending') return;
//     setLocStatus('pending');

//     const rid = ++locRequestIdRef.current;

//     void (async () => {
//       const res = await getCurrentPositionSafe(
//         { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
//         12000
//       );
//       if (locRequestIdRef.current !== rid) return;

//       if (!res.ok) {
//         if (res.reason === 'unavailable') setLocStatus('unavailable');
//         else if (res.reason === 'denied') setLocStatus('denied');
//         else setLocStatus('error');
//         return;
//       }

//       const next = { lat: res.pos.lat, lng: res.pos.lng };
//       setUserPos(next);
//       setLocStatus('ready');

//       writeCachedPosition(next, { key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' });

//       setResetKind('order');
//       setDistanceReadyToken((v) => v + 1);
//     })();
//   }, [locStatus, userPos]);

//   // distance 模式：只要求定位，不先載 crtime
//   useEffect(() => {
//     if (orderBy !== 'distance') return;
//     if (userPos) return;
//     if (locStatus === 'idle') startLocationRequest();
//   }, [orderBy, userPos, locStatus, startLocationRequest]);

//   // ✅ 關鍵修正：回到頁面（上一頁）時，distance 一律觸發 reset（避免 route cache/bfcache 還原舊狀態）
//   const orderByRef = useRef(orderBy);
//   useEffect(() => {
//     orderByRef.current = orderBy;
//   }, [orderBy]);

//   const [resumeToken, setResumeToken] = useState(0);

//   useEffect(() => {
//     if (typeof window === 'undefined') return;

//     const bumpIfDistance = () => {
//       if (orderByRef.current !== 'distance') return;

//       // 回來時再讀一次快取，避免 userPos 在某些還原情境為 null
//       const cached = toLatLng(
//         readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//       );
//       if (!userPos && cached) {
//         setUserPos(cached);
//         setLocStatus('ready');
//         setDistanceReadyToken((v) => v + 1);
//       } else if (!userPos && locStatus === 'idle') {
//         startLocationRequest();
//       }

//       // 強制讓 resetKey 變動，讓 InfiniteList 重新抓 distance
//       setResetKind('order');
//       setResumeToken((v) => v + 1);
//     };

//     const onPageShow = () => bumpIfDistance();
//     const onFocus = () => bumpIfDistance();
//     const onVis = () => {
//       if (document.visibilityState === 'visible') bumpIfDistance();
//     };

//     window.addEventListener('pageshow', onPageShow);
//     window.addEventListener('focus', onFocus);
//     document.addEventListener('visibilitychange', onVis);

//     return () => {
//       window.removeEventListener('pageshow', onPageShow);
//       window.removeEventListener('focus', onFocus);
//       document.removeEventListener('visibilitychange', onVis);
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [locStatus, startLocationRequest, userPos]);

//   // =========================
//   // groups
//   // =========================
//   const [internalGroups, setInternalGroups] = useState<ArSpaceGroup[]>([]);
//   const arspaceGroups = groups ?? internalGroups;

//   useEffect(() => {
//     if (!enableGroups) return;
//     if (groups) return;

//     const run = async () => {
//       try {
//         const list = await ArSpaceService.getArSpaceGroup({ withAuth: false });
//         setInternalGroups(list);
//       } catch {
//         setInternalGroups([]);
//       }
//     };
//     void run();
//   }, [enableGroups, groups]);

//   // =========================
//   // modals
//   // =========================
//   const [scanOpen, setScanOpen] = useState(false);
//   const [scanPic, setScanPic] = useState<string | undefined>(undefined);
//   const [mapOpen, setMapOpen] = useState(false);
//   const [mapTitle, setMapTitle] = useState('');
//   const [mapQuery, setMapQuery] = useState('');

//   const openScan = useCallback((item: ArSpace) => {
//     setScanPic(item.cover);
//     setScanOpen(true);
//   }, []);

//   const openMap = useCallback((item: ArSpace) => {
//     const query = (item.address || '').trim() || (item.branch_name || '').trim() || item.title;
//     setMapTitle(item.branch_name);
//     setMapQuery(query);
//     setMapOpen(true);
//   }, []);

//   // hidden ids
//   const [hiddenIds, setHiddenIds] = useState<Set<string | number>>(() => new Set());
//   const handleDeleted = useCallback((deletedId: string | number) => {
//     setHiddenIds((prev) => {
//       if (prev.has(deletedId)) return prev;
//       const next = new Set(prev);
//       next.add(deletedId);
//       return next;
//     });
//   }, []);

//   // dedupe
//   const seenIdsRef = useRef<Set<string>>(new Set());

//   // page base
//   const pageBaseRef = useRef<0 | 1 | null>(null);

//   const fetchArSpace = useCallback(
//     async ({
//       page,
//       pageSize,
//     }: {
//       page: number;
//       pageSize?: number;
//     }): Promise<{ items: ArSpace[]; hasMore: boolean }> => {
//       const size = pageSize ?? PAGE_SIZE;

//       const rawPage = Number(page);
//       const safeRaw = Number.isFinite(rawPage) ? rawPage : 1;

//       if (pageBaseRef.current === null) {
//         pageBaseRef.current = safeRaw === 0 ? 0 : 1;
//       }

//       const pageParam = pageBaseRef.current === 0 ? Math.max(1, safeRaw + 1) : Math.max(1, safeRaw);

//       const arTypeParam = resolveArTypeParam(filterKind, tab);

//       // ✅ distance：沒有定位就不打 API
//       if (orderBy === 'distance' && !userPos) {
//         if (locStatus === 'idle') startLocationRequest();
//         return { items: [], hasMore: false };
//       }

//       const params: {
//         page: number;
//         keywords?: string;
//         ar_type?: ArType;
//         order_by: OrderBy;
//         latitude?: number;
//         longitude?: number;
//         store_id?: number | string;
//         owner_open_id?: number | string;
//       } = {
//         page: pageParam,
//         order_by: orderBy,
//       };

//       if (debouncedKeyword) params.keywords = debouncedKeyword;
//       if (arTypeParam) params.ar_type = arTypeParam;

//       if (orderBy === 'distance' && userPos) {
//         params.latitude = userPos.lat;
//         params.longitude = userPos.lng;
//       }

//       if (filterKind === 'store' && filterId != null) params.store_id = filterId;
//       if (filterKind === 'kol' && filterId != null) params.owner_open_id = String(filterId);

//       try {
//         const data = await ArSpaceService.list(params, { withAuth: false });
//         const list = (data.items ?? []) as ArSpaceExtended[];

//         let filtered = list;
//         filtered = applyOwnerOrStoreFilter(filtered, filterKind, filterId);
//         filtered = applyArTypeFilter(filtered, filterKind, tab);

//         if (enableGroups) filtered = applyGroupFilter(filtered, groupId, arspaceGroups);

//         const seen = seenIdsRef.current;
//         const deduped = filtered.filter((item) => {
//           const id = String(item.id ?? '');
//           if (!id) return true;
//           if (seen.has(id)) return false;
//           seen.add(id);
//           return true;
//         });

//         let finalItems: ArSpaceExtended[] = deduped;

//         // ✅ 前端 double-check distance 排序
//         if (orderBy === 'distance' && userPos) {
//           const withDist = finalItems.map((it) => ({ it, d: getDistanceMeters(userPos, it) }));
//           withDist.sort((a, b) => {
//             const da = a.d ?? Number.POSITIVE_INFINITY;
//             const db = b.d ?? Number.POSITIVE_INFINITY;
//             if (da !== db) return da - db;
//             return String(a.it.id).localeCompare(String(b.it.id));
//           });
//           finalItems = withDist.map((x) => x.it);
//         }

//         let hasMore = false;
//         if (list.length < size) hasMore = false;
//         else if (finalItems.length === 0 && pageParam > 1) hasMore = false;
//         else hasMore = true;

//         return { items: finalItems, hasMore };
//       } catch {
//         return { items: [], hasMore: false };
//       }
//     },
//     [
//       arspaceGroups,
//       debouncedKeyword,
//       enableGroups,
//       filterId,
//       filterKind,
//       groupId,
//       locStatus,
//       orderBy,
//       startLocationRequest,
//       tab,
//       userPos,
//     ]
//   );

//   const resetKey = useMemo(() => {
//     const groupPart = enableGroups ? groupId : 'nogroup';
//     const distPart =
//       orderBy === 'distance'
//         ? userPos
//           ? `pos:${userPos.lat.toFixed(6)},${userPos.lng.toFixed(6)}|tok:${distanceReadyToken}|resume:${resumeToken}`
//           : `nopos:${locStatus}|tok:${distanceReadyToken}|resume:${resumeToken}`
//         : 'nodist';

//     return `${filterKind ?? 'all'}|${filterId ?? 'all'}|${tab}|${debouncedKeyword}|${orderBy}|${groupPart}|${distPart}`;
//   }, [
//     debouncedKeyword,
//     distanceReadyToken,
//     enableGroups,
//     filterId,
//     filterKind,
//     groupId,
//     locStatus,
//     orderBy,
//     resumeToken,
//     tab,
//     userPos,
//   ]);

//   useEffect(() => {
//     seenIdsRef.current = new Set();
//     pageBaseRef.current = null;
//   }, [resetKey]);

//   const renderCardSkeleton = useCallback(
//     (idx: number) => (
//       <div className="col" key={`sk-col-${idx}`}>
//         <div className="card h-100">
//           <div className="position-relative">
//             <Skeleton width="100%" height="160px" radius="0.375rem" />
//           </div>
//           <div className="card-body p-3">
//             <div className="d-flex align-items-center mb-2">
//               <Skeleton width="30px" height="30px" radius="50%" />
//               <Skeleton width="60px" height="12px" radius="4px" className="ms-2" />
//             </div>
//             <Skeleton width="80%" height="16px" radius="4px" />
//           </div>
//           <div className="card-footer">
//             <Skeleton width="70%" height="12px" radius="4px" />
//           </div>
//         </div>
//       </div>
//     ),
//     []
//   );

//   const emptyView = useMemo(() => {
//     if (orderBy === 'distance' && !userPos) {
//       if (locStatus === 'pending' || locStatus === 'idle') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             正在取得定位中…
//             <div className="small text-muted mt-2">若跳出權限提示請按「允許」</div>
//           </div>
//         );
//       }
//       if (locStatus === 'denied') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             距離排序需要定位權限
//             <div className="small text-muted mt-2">請在瀏覽器設定允許定位，或改用「依最新→舊」</div>
//           </div>
//         );
//       }
//       if (locStatus === 'unavailable') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             此裝置不支援定位
//             <div className="small text-muted mt-2">請改用「依最新→舊」</div>
//           </div>
//         );
//       }
//       return (
//         <div className="text-grey text-center py-5 w-100">
//           <span className="d-block mb-3">
//             <ArSpaceOutlineIcon width={60} />
//           </span>
//           取得定位失敗
//           <div className="small text-muted mt-2">請稍後再試或改用其他排序</div>
//           <button
//             type="button"
//             className="btn btn-outline-secondary btn-sm mt-3"
//             onClick={() => {
//               setLocStatus('idle');
//               startLocationRequest();
//             }}
//           >
//             重新嘗試定位
//           </button>
//         </div>
//       );
//     }

//     return <EmptyState {...buildEmptyState(EMPTY.arSpace.noPosts)} />;
//   }, [locStatus, orderBy, startLocationRequest, userPos]);

//   return (
//     <>
//       <InfiniteListWithFetch<ArSpace>
//         fetchData={fetchArSpace}
//         getKey={(item, idx) => `${(item as ArSpaceExtended).id}-${idx}`}
//         renderItem={(item) =>
//           hiddenIds.has(item.id) ? null : (
//             <ArSpaceCard
//               item={item}
//               onOpenScan={openScan}
//               onOpenMap={openMap}
//               highlight={highlightText}
//               onDeleted={handleDeleted}
//             />
//           )
//         }
//         resetKey={resetKey}
//         resetKind={resetKind}
//         className={listClassName ?? 'row row-cols-2 row-cols-md-3 row-cols-xl-4 g-4'}
//         renderSkeleton={renderCardSkeleton}
//         skeletonMode="matchLoadedOrPrev"
//         skeletonInitialCount={5}
//         rootMargin="200px"
//         emptyView={emptyView}
//         errorView={<div className="col-12 text-center py-4 text-danger">載入失敗，請稍後再試</div>}
//         bootingSkeletonModeMap={{
//           keyword: 'none',
//           tab: 'prevCount',
//           order: 'prevCount',
//           group: 'prevCount',
//           other: 'prevCount',
//         }}
//         pageSize={PAGE_SIZE}
//       />

//       <ArScanModal
//         open={scanOpen}
//         onClose={() => setScanOpen(false)}
//         scanPic={scanPic}
//         onScan={() => {
//           console.log('Start scanning…');
//           setScanOpen(false);
//         }}
//       />

//       <MapModal
//         open={mapOpen}
//         title={mapTitle}
//         query={mapQuery}
//         onClose={() => setMapOpen(false)}
//       />
//     </>
//   );
// };

// export default ArSpaceList;

// // src/components/page/ar-space/ArSpaceList.tsx
// 'use client';

// import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

// // components
// import InfiniteListWithFetch from '@/components/ui/list/InfiniteListWithFetch';
// import Skeleton from '@/components/ui/skeleton/Skeleton';
// import ArScanModal from '@/components/ui/modal/ArScanModal';
// import MapModal from '@/components/ui/modal/MapModal';
// import ArSpaceCard from '@/components/page/ar-space/ArSpaceCard';
// import { EmptyState, EMPTY, buildEmptyState } from '@/components/ui/emptyState';

// // data
// import type { ArSpace, ArType, ArSpaceGroup, OrderBy } from '@/types/arSpace';
// import { ArSpaceService } from '@/libs/services/arSpace';

// import ArSpaceOutlineIcon from '@/components/icons/ArSpaceOutlineIcon';

// // ✅ 共用定位快取工具
// import {
//   readCachedPosition,
//   writeCachedPosition,
//   getCurrentPositionSafe,
//   type LatLng as GeoLatLng,
// } from '@/libs/location/geoCache';

// // ✅ 後端文件：一頁 20 筆（前端 pageSize 也用 20 最穩）
// const PAGE_SIZE = 20;

// type FilterKind = 'kol' | 'store';
// type TabKind = 'all' | ArType;
// type LatLng = { lat: number; lng: number };
// type ResetKind = 'keyword' | 'tab' | 'order' | 'group' | 'other';

// type LocationStatus = 'idle' | 'pending' | 'ready' | 'denied' | 'unavailable' | 'error';

// const GEO_CACHE_KEY = 'arspace_user_pos_v1';
// const GEO_CACHE_TTL = 30 * 60 * 1000; // 30 min

// type ArSpaceExtended = ArSpace & {
//   ar_type?: ArType | string;
//   store_id?: number | string;
//   storeId?: number | string;
//   owner_open_id?: string;
//   ownerOpenId?: string;
// };

// export type ArSpaceListFilters = {
//   tab: TabKind;
//   keyword: string;
//   orderBy: OrderBy;
//   groupId: string;
// };

// /** ------------------------------
//  * Props：用 discriminated union
//  * - filterKind='store' 時，tab 只能是 'branch'
//  * - filterKind='kol' 時，tab 只能是 'ar_space'
//  * ------------------------------ */
// type BaseProps = {
//   listClassName?: string;

//   filters?: Partial<ArSpaceListFilters>;
//   onFiltersChange?: (next: ArSpaceListFilters) => void;

//   enableGroups?: boolean;
//   groups?: ArSpaceGroup[];
// };

// type StoreProps = BaseProps & {
//   filterKind: 'store';
//   filterId: number | string;
//   filters?: Partial<Omit<ArSpaceListFilters, 'tab'>> & { tab?: 'branch' };
// };

// type KolProps = BaseProps & {
//   filterKind: 'kol';
//   filterId: number | string;
//   filters?: Partial<Omit<ArSpaceListFilters, 'tab'>> & { tab?: 'ar_space' };
// };

// type NormalProps = BaseProps & {
//   filterKind?: undefined;
//   filterId?: undefined;
// };

// type Props = StoreProps | KolProps | NormalProps;

// const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// function resolveArTypeParam(filterKind: FilterKind | undefined, tab: TabKind): '' | ArType {
//   if (filterKind === 'store') return 'branch';
//   if (filterKind === 'kol') return 'ar_space';
//   return tab === 'branch' ? 'branch' : tab === 'ar_space' ? 'ar_space' : '';
// }

// function applyOwnerOrStoreFilter(
//   list: ArSpaceExtended[],
//   filterKind: FilterKind | undefined,
//   filterId: number | string | undefined
// ): ArSpaceExtended[] {
//   if (!filterKind || filterId == null) return list;

//   if (filterKind === 'store') {
//     const targetStr = String(filterId);
//     const targetNum = Number(filterId);
//     return list.filter((item) => {
//       const raw = item.store_id;
//       const norm = item.storeId;
//       return (
//         (raw != null && String(raw) === targetStr) || (norm != null && Number(norm) === targetNum)
//       );
//     });
//   }

//   if (filterKind === 'kol') {
//     const target = String(filterId);
//     return list.filter((item) => {
//       const raw = item.owner_open_id;
//       const norm = item.ownerOpenId;
//       return (raw != null && String(raw) === target) || (norm != null && String(norm) === target);
//     });
//   }

//   return list;
// }

// function applyArTypeFilter(
//   list: ArSpaceExtended[],
//   filterKind: FilterKind | undefined,
//   tab: TabKind
// ): ArSpaceExtended[] {
//   if (filterKind === 'store') return list.filter((i) => i.ar_type === 'branch');
//   if (filterKind === 'kol') return list.filter((i) => i.ar_type === 'ar_space');
//   if (tab !== 'all') return list.filter((i) => i.ar_type === tab);
//   return list;
// }

// function applyGroupFilter(
//   list: ArSpaceExtended[],
//   groupId: string,
//   arspaceGroups: ArSpaceGroup[]
// ): ArSpaceExtended[] {
//   if (groupId === 'all') return list;

//   const selectedGroup = arspaceGroups.find((g) => String(g.id) === groupId);
//   if (!selectedGroup || selectedGroup.data.length === 0) return list;

//   const allowedStoreIds = new Set<number>(selectedGroup.data);

//   return list.filter((item) => {
//     const storeId = item.store_id;
//     if (storeId == null) return false;
//     const num = typeof storeId === 'number' ? storeId : Number(storeId);
//     if (Number.isNaN(num)) return false;
//     return allowedStoreIds.has(num);
//   });
// }

// function parseLatLng(latitude?: string, longitude?: string): LatLng | null {
//   if (!latitude || !longitude) return null;
//   const lat = Number(latitude);
//   const lng = Number(longitude);
//   if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
//   if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
//   return { lat, lng };
// }

// function haversineMeters(a: LatLng, b: LatLng): number {
//   const R = 6371000;
//   const toRad = (deg: number) => (deg * Math.PI) / 180;

//   const dLat = toRad(b.lat - a.lat);
//   const dLng = toRad(b.lng - a.lng);

//   const lat1 = toRad(a.lat);
//   const lat2 = toRad(b.lat);

//   const sinDLat = Math.sin(dLat / 2);
//   const sinDLng = Math.sin(dLng / 2);

//   const h = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * (sinDLng * sinDLng);
//   return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
// }

// function getDistanceMeters(user: LatLng, item: ArSpaceExtended): number | null {
//   const pos = parseLatLng(item.latitude, item.longitude);
//   if (!pos) return null;
//   return haversineMeters(user, pos);
// }

// function toLatLng(p: GeoLatLng | null): LatLng | null {
//   if (!p) return null;
//   return { lat: p.lat, lng: p.lng };
// }

// const ArSpaceList: React.FC<Props> = ({
//   filterKind,
//   filterId,
//   listClassName,
//   filters,
//   enableGroups = true,
//   groups,
// }) => {
//   // ✅ runtime 防呆：store 一律 branch；kol 一律 ar_space
//   const rawTab: TabKind = filters?.tab ?? 'all';
//   const tab: TabKind =
//     filterKind === 'store' ? 'branch' : filterKind === 'kol' ? 'ar_space' : rawTab;

//   const keyword: string = filters?.keyword ?? '';
//   const orderBy: OrderBy = filters?.orderBy ?? 'crtime';
//   const groupId: string = filters?.groupId ?? 'all';

//   const [resetKind, setResetKind] = useState<ResetKind>('other');

//   // debounce keyword（只影響 fetch / highlight）
//   const [debouncedKeyword, setDebouncedKeyword] = useState('');
//   const debouncedKeywordRef = useRef<string>('');
//   useEffect(() => {
//     const next = keyword.trim();
//     const timer = window.setTimeout(() => {
//       if (debouncedKeywordRef.current === next) return;
//       debouncedKeywordRef.current = next;
//       setDebouncedKeyword(next);
//       setResetKind('keyword');
//     }, 350);
//     return () => window.clearTimeout(timer);
//   }, [keyword]);

//   const highlightText = useCallback(
//     (text: string): React.ReactNode => {
//       if (!debouncedKeyword) return text;
//       const safe = escapeRegExp(debouncedKeyword);
//       const parts = text.split(new RegExp(`(${safe})`, 'gi'));
//       return parts.map((part, i) =>
//         part.toLowerCase() === debouncedKeyword.toLowerCase() ? (
//           <mark key={i} className="fw-bold" style={{ backgroundColor: '#fff2f2' }}>
//             {part}
//           </mark>
//         ) : (
//           part
//         )
//       );
//     },
//     [debouncedKeyword]
//   );

//   // =========================
//   // ✅ distance：定位（含快取）
//   // =========================
//   const [userPos, setUserPos] = useState<LatLng | null>(() => {
//     const cached = toLatLng(
//       readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//     );
//     return cached;
//   });
//   const [locStatus, setLocStatus] = useState<LocationStatus>(() => (userPos ? 'ready' : 'idle'));
//   const [distanceReadyToken, setDistanceReadyToken] = useState(0);

//   const locRequestIdRef = useRef(0);

//   const startLocationRequest = useCallback(() => {
//     // 先用快取救回
//     const cached = toLatLng(
//       readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//     );
//     if (!userPos && cached) {
//       setUserPos(cached);
//       setLocStatus('ready');
//       setResetKind('order');
//       setDistanceReadyToken((v) => v + 1);
//       return;
//     }

//     if (userPos) {
//       setLocStatus('ready');
//       return;
//     }

//     if (locStatus === 'pending') return;
//     setLocStatus('pending');

//     const rid = ++locRequestIdRef.current;

//     void (async () => {
//       const res = await getCurrentPositionSafe(
//         { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
//         12000
//       );
//       if (locRequestIdRef.current !== rid) return;

//       if (!res.ok) {
//         if (res.reason === 'unavailable') setLocStatus('unavailable');
//         else if (res.reason === 'denied') setLocStatus('denied');
//         else setLocStatus('error');
//         return;
//       }

//       const next = { lat: res.pos.lat, lng: res.pos.lng };
//       setUserPos(next);
//       setLocStatus('ready');

//       writeCachedPosition(next, { key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' });

//       setResetKind('order');
//       setDistanceReadyToken((v) => v + 1);
//     })();
//   }, [locStatus, userPos]);

//   // distance 模式：只要求定位，不先載 crtime
//   useEffect(() => {
//     if (orderBy !== 'distance') return;
//     if (userPos) return;
//     if (locStatus === 'idle') startLocationRequest();
//   }, [orderBy, userPos, locStatus, startLocationRequest]);

//   // ✅ 關鍵修正：回到頁面（上一頁）時，distance 一律觸發 reset（避免 route cache/bfcache 還原舊狀態）
//   const orderByRef = useRef(orderBy);
//   useEffect(() => {
//     orderByRef.current = orderBy;
//   }, [orderBy]);

//   const [resumeToken, setResumeToken] = useState(0);

//   useEffect(() => {
//     if (typeof window === 'undefined') return;

//     const bumpIfDistance = () => {
//       if (orderByRef.current !== 'distance') return;

//       // 回來時再讀一次快取，避免 userPos 在某些還原情境為 null
//       const cached = toLatLng(
//         readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//       );
//       if (!userPos && cached) {
//         setUserPos(cached);
//         setLocStatus('ready');
//         setDistanceReadyToken((v) => v + 1);
//       } else if (!userPos && locStatus === 'idle') {
//         startLocationRequest();
//       }

//       // 強制讓 resetKey 變動，讓 InfiniteList 重新抓 distance
//       setResetKind('order');
//       setResumeToken((v) => v + 1);
//     };

//     const onPageShow = () => bumpIfDistance();
//     const onFocus = () => bumpIfDistance();
//     const onVis = () => {
//       if (document.visibilityState === 'visible') bumpIfDistance();
//     };

//     window.addEventListener('pageshow', onPageShow);
//     window.addEventListener('focus', onFocus);
//     document.addEventListener('visibilitychange', onVis);

//     return () => {
//       window.removeEventListener('pageshow', onPageShow);
//       window.removeEventListener('focus', onFocus);
//       document.removeEventListener('visibilitychange', onVis);
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [locStatus, startLocationRequest, userPos]);

//   // =========================
//   // groups
//   // =========================
//   const [internalGroups, setInternalGroups] = useState<ArSpaceGroup[]>([]);
//   const arspaceGroups = groups ?? internalGroups;

//   useEffect(() => {
//     if (!enableGroups) return;
//     if (groups) return;

//     const run = async () => {
//       try {
//         const list = await ArSpaceService.getArSpaceGroup({ withAuth: false });
//         setInternalGroups(list);
//       } catch {
//         setInternalGroups([]);
//       }
//     };
//     void run();
//   }, [enableGroups, groups]);

//   // =========================
//   // modals
//   // =========================
//   const [scanOpen, setScanOpen] = useState(false);
//   const [scanPic, setScanPic] = useState<string | undefined>(undefined);
//   const [mapOpen, setMapOpen] = useState(false);
//   const [mapTitle, setMapTitle] = useState('');
//   const [mapQuery, setMapQuery] = useState('');

//   const openScan = useCallback((item: ArSpace) => {
//     setScanPic(item.cover);
//     setScanOpen(true);
//   }, []);

//   const openMap = useCallback((item: ArSpace) => {
//     const query = (item.address || '').trim() || (item.branch_name || '').trim() || item.title;
//     setMapTitle(item.branch_name);
//     setMapQuery(query);
//     setMapOpen(true);
//   }, []);

//   // hidden ids
//   const [hiddenIds, setHiddenIds] = useState<Set<string | number>>(() => new Set());
//   const handleDeleted = useCallback((deletedId: string | number) => {
//     setHiddenIds((prev) => {
//       if (prev.has(deletedId)) return prev;
//       const next = new Set(prev);
//       next.add(deletedId);
//       return next;
//     });
//   }, []);

//   // dedupe
//   const seenIdsRef = useRef<Set<string>>(new Set());

//   // page base
//   const pageBaseRef = useRef<0 | 1 | null>(null);

//   const fetchArSpace = useCallback(
//     async ({
//       page,
//       pageSize,
//     }: {
//       page: number;
//       pageSize?: number;
//     }): Promise<{ items: ArSpace[]; hasMore: boolean }> => {
//       const size = pageSize ?? PAGE_SIZE;

//       const rawPage = Number(page);
//       const safeRaw = Number.isFinite(rawPage) ? rawPage : 1;

//       if (pageBaseRef.current === null) {
//         pageBaseRef.current = safeRaw === 0 ? 0 : 1;
//       }

//       const pageParam = pageBaseRef.current === 0 ? Math.max(1, safeRaw + 1) : Math.max(1, safeRaw);

//       const arTypeParam = resolveArTypeParam(filterKind, tab);

//       // ✅ distance：沒有定位就不打 API
//       if (orderBy === 'distance' && !userPos) {
//         if (locStatus === 'idle') startLocationRequest();
//         return { items: [], hasMore: false };
//       }

//       const params: {
//         page: number;
//         keywords?: string;
//         ar_type?: ArType;
//         order_by: OrderBy;
//         latitude?: number;
//         longitude?: number;
//         store_id?: number | string;
//         owner_open_id?: number | string;
//       } = {
//         page: pageParam,
//         order_by: orderBy,
//       };

//       if (debouncedKeyword) params.keywords = debouncedKeyword;
//       if (arTypeParam) params.ar_type = arTypeParam;

//       if (orderBy === 'distance' && userPos) {
//         params.latitude = userPos.lat;
//         params.longitude = userPos.lng;
//       }

//       // ✅ store_id 建議傳 number（避免後端嚴格型別忽略）
//       if (filterKind === 'store' && filterId != null) {
//         const n = Number(filterId);
//         params.store_id = Number.isNaN(n) ? filterId : n;
//       }

//       if (filterKind === 'kol' && filterId != null) params.owner_open_id = String(filterId);

//       try {
//         const data = await ArSpaceService.list(params, { withAuth: false });
//         const list = (data.items ?? []) as ArSpaceExtended[];

//         let filtered = list;

//         filtered = applyOwnerOrStoreFilter(filtered, filterKind, filterId);

//         // ✅ store/kol 已透過 ar_type 參數讓後端篩過，避免 ar_type 欄位缺失導致整頁被濾光
//         if (!filterKind) {
//           filtered = applyArTypeFilter(filtered, filterKind, tab);
//         }

//         if (enableGroups) filtered = applyGroupFilter(filtered, groupId, arspaceGroups);

//         const seen = seenIdsRef.current;
//         const deduped = filtered.filter((item) => {
//           const id = String(item.id ?? '');
//           if (!id) return true;
//           if (seen.has(id)) return false;
//           seen.add(id);
//           return true;
//         });

//         let finalItems: ArSpaceExtended[] = deduped;

//         // ✅ 前端 double-check distance 排序
//         if (orderBy === 'distance' && userPos) {
//           const withDist = finalItems.map((it) => ({ it, d: getDistanceMeters(userPos, it) }));
//           withDist.sort((a, b) => {
//             const da = a.d ?? Number.POSITIVE_INFINITY;
//             const db = b.d ?? Number.POSITIVE_INFINITY;
//             if (da !== db) return da - db;
//             return String(a.it.id).localeCompare(String(b.it.id));
//           });
//           finalItems = withDist.map((x) => x.it);
//         }

//         // ✅ hasMore：用後端 total/page_size 算，不要用 finalItems（前端過濾後）避免提早停
//         const backendPageNo = Number.isFinite(data.page) ? data.page : pageParam;
//         const backendPageSize =
//           Number.isFinite(data.page_size) && data.page_size > 0 ? data.page_size : size;

//         // 若 total 不可靠（例如上游偶爾直接回 array，你的 list() 兼容會讓 total === items.length）
//         // 就 fallback 以「本頁是否滿 size」判斷，寧可多打一頁，也不要提早停
//         const hasReliableTotal =
//           Number.isFinite(data.total) && data.total > backendPageSize && data.total >= 0;

//         const hasMore = hasReliableTotal
//           ? backendPageNo * backendPageSize < data.total
//           : list.length >= size;

//         return { items: finalItems, hasMore };
//       } catch {
//         return { items: [], hasMore: false };
//       }
//     },
//     [
//       arspaceGroups,
//       debouncedKeyword,
//       enableGroups,
//       filterId,
//       filterKind,
//       groupId,
//       locStatus,
//       orderBy,
//       startLocationRequest,
//       tab,
//       userPos,
//     ]
//   );

//   const resetKey = useMemo(() => {
//     const groupPart = enableGroups ? groupId : 'nogroup';
//     const distPart =
//       orderBy === 'distance'
//         ? userPos
//           ? `pos:${userPos.lat.toFixed(6)},${userPos.lng.toFixed(6)}|tok:${distanceReadyToken}|resume:${resumeToken}`
//           : `nopos:${locStatus}|tok:${distanceReadyToken}|resume:${resumeToken}`
//         : 'nodist';

//     return `${filterKind ?? 'all'}|${filterId ?? 'all'}|${tab}|${debouncedKeyword}|${orderBy}|${groupPart}|${distPart}`;
//   }, [
//     debouncedKeyword,
//     distanceReadyToken,
//     enableGroups,
//     filterId,
//     filterKind,
//     groupId,
//     locStatus,
//     orderBy,
//     resumeToken,
//     tab,
//     userPos,
//   ]);

//   useEffect(() => {
//     seenIdsRef.current = new Set();
//     pageBaseRef.current = null;
//   }, [resetKey]);

//   const renderCardSkeleton = useCallback(
//     (idx: number) => (
//       <div className="col" key={`sk-col-${idx}`}>
//         <div className="card h-100">
//           <div className="position-relative">
//             <Skeleton width="100%" height="160px" radius="0.375rem" />
//           </div>
//           <div className="card-body p-3">
//             <div className="d-flex align-items-center mb-2">
//               <Skeleton width="30px" height="30px" radius="50%" />
//               <Skeleton width="60px" height="12px" radius="4px" className="ms-2" />
//             </div>
//             <Skeleton width="80%" height="16px" radius="4px" />
//           </div>
//           <div className="card-footer">
//             <Skeleton width="70%" height="12px" radius="4px" />
//           </div>
//         </div>
//       </div>
//     ),
//     []
//   );

//   const emptyView = useMemo(() => {
//     if (orderBy === 'distance' && !userPos) {
//       if (locStatus === 'pending' || locStatus === 'idle') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             正在取得定位中…
//             <div className="small text-muted mt-2">若跳出權限提示請按「允許」</div>
//           </div>
//         );
//       }
//       if (locStatus === 'denied') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             距離排序需要定位權限
//             <div className="small text-muted mt-2">請在瀏覽器設定允許定位，或改用「依最新→舊」</div>
//           </div>
//         );
//       }
//       if (locStatus === 'unavailable') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             此裝置不支援定位
//             <div className="small text-muted mt-2">請改用「依最新→舊」</div>
//           </div>
//         );
//       }
//       return (
//         <div className="text-grey text-center py-5 w-100">
//           <span className="d-block mb-3">
//             <ArSpaceOutlineIcon width={60} />
//           </span>
//           取得定位失敗
//           <div className="small text-muted mt-2">請稍後再試或改用其他排序</div>
//           <button
//             type="button"
//             className="btn btn-outline-secondary btn-sm mt-3"
//             onClick={() => {
//               setLocStatus('idle');
//               startLocationRequest();
//             }}
//           >
//             重新嘗試定位
//           </button>
//         </div>
//       );
//     }

//     return <EmptyState {...buildEmptyState(EMPTY.arSpace.noPosts)} />;
//   }, [locStatus, orderBy, startLocationRequest, userPos]);

//   return (
//     <>
//       <InfiniteListWithFetch<ArSpace>
//         fetchData={fetchArSpace}
//         getKey={(item, idx) => `${(item as ArSpaceExtended).id}-${idx}`}
//         renderItem={(item) =>
//           hiddenIds.has(item.id) ? null : (
//             <ArSpaceCard
//               item={item}
//               onOpenScan={openScan}
//               onOpenMap={openMap}
//               highlight={highlightText}
//               onDeleted={handleDeleted}
//             />
//           )
//         }
//         resetKey={resetKey}
//         resetKind={resetKind}
//         className={listClassName ?? 'row row-cols-2 row-cols-md-3 row-cols-xl-4 g-4'}
//         renderSkeleton={renderCardSkeleton}
//         skeletonMode="matchLoadedOrPrev"
//         skeletonInitialCount={5}
//         rootMargin="200px"
//         emptyView={emptyView}
//         errorView={<div className="col-12 text-center py-4 text-danger">載入失敗，請稍後再試</div>}
//         bootingSkeletonModeMap={{
//           keyword: 'none',
//           tab: 'prevCount',
//           order: 'prevCount',
//           group: 'prevCount',
//           other: 'prevCount',
//         }}
//         pageSize={PAGE_SIZE}
//       />

//       <ArScanModal
//         open={scanOpen}
//         onClose={() => setScanOpen(false)}
//         scanPic={scanPic}
//         onScan={() => {
//           console.log('Start scanning…');
//           setScanOpen(false);
//         }}
//       />

//       <MapModal
//         open={mapOpen}
//         title={mapTitle}
//         query={mapQuery}
//         onClose={() => setMapOpen(false)}
//       />
//     </>
//   );
// };

// export default ArSpaceList;

// // src/components/page/ar-space/ArSpaceList.tsx (filterKind === 'store'加入tab: 'branch'版本)
// 'use client';

// import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

// // components
// import InfiniteListWithFetch from '@/components/ui/list/InfiniteListWithFetch';
// import Skeleton from '@/components/ui/skeleton/Skeleton';
// import ArScanModal from '@/components/ui/modal/ArScanModal';
// import MapModal from '@/components/ui/modal/MapModal';
// import ArSpaceCard from '@/components/page/ar-space/ArSpaceCard';
// import { EmptyState, EMPTY, buildEmptyState } from '@/components/ui/emptyState';

// // data
// import type { ArSpace, ArType, ArSpaceGroup, OrderBy } from '@/types/arSpace';
// import { ArSpaceService } from '@/libs/services/arSpace';

// import ArSpaceOutlineIcon from '@/components/icons/ArSpaceOutlineIcon';

// // ✅ 共用定位快取工具
// import {
//   readCachedPosition,
//   writeCachedPosition,
//   getCurrentPositionSafe,
//   type LatLng as GeoLatLng,
// } from '@/libs/location/geoCache';

// // ✅ 後端文件：一頁 20 筆（前端 pageSize 也用 20 最穩）
// const PAGE_SIZE = 20;

// type FilterKind = 'kol' | 'store';
// type TabKind = 'all' | ArType;
// type LatLng = { lat: number; lng: number };
// type ResetKind = 'keyword' | 'tab' | 'order' | 'group' | 'other';

// type LocationStatus = 'idle' | 'pending' | 'ready' | 'denied' | 'unavailable' | 'error';

// const GEO_CACHE_KEY = 'arspace_user_pos_v1';
// const GEO_CACHE_TTL = 30 * 60 * 1000; // 30 min

// type ArSpaceExtended = ArSpace & {
//   ar_type?: ArType | string;
//   store_id?: number | string;
//   storeId?: number | string;
//   owner_open_id?: string;
//   ownerOpenId?: string;
// };

// export type ArSpaceListFilters = {
//   tab: TabKind;
//   keyword: string;
//   orderBy: OrderBy;
//   groupId: string;
// };

// type Props = {
//   filterKind?: FilterKind;
//   filterId?: number | string;
//   listClassName?: string;

//   filters?: Partial<ArSpaceListFilters>;
//   onFiltersChange?: (next: ArSpaceListFilters) => void;

//   enableGroups?: boolean;
//   groups?: ArSpaceGroup[];
// };

// const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// function resolveArTypeParam(filterKind: FilterKind | undefined, tab: TabKind): '' | ArType {
//   if (filterKind === 'store') return 'branch';
//   if (filterKind === 'kol') return 'ar_space';
//   return tab === 'branch' ? 'branch' : tab === 'ar_space' ? 'ar_space' : '';
// }

// function applyOwnerOrStoreFilter(
//   list: ArSpaceExtended[],
//   filterKind: FilterKind | undefined,
//   filterId: number | string | undefined
// ): ArSpaceExtended[] {
//   if (!filterKind || filterId == null) return list;

//   if (filterKind === 'store') {
//     const targetStr = String(filterId);
//     const targetNum = Number(filterId);
//     return list.filter((item) => {
//       const raw = item.store_id;
//       const norm = item.storeId;
//       return (
//         (raw != null && String(raw) === targetStr) || (norm != null && Number(norm) === targetNum)
//       );
//     });
//   }

//   if (filterKind === 'kol') {
//     const target = String(filterId);
//     return list.filter((item) => {
//       const raw = item.owner_open_id;
//       const norm = item.ownerOpenId;
//       return (raw != null && String(raw) === target) || (norm != null && String(norm) === target);
//     });
//   }

//   return list;
// }

// function applyArTypeFilter(
//   list: ArSpaceExtended[],
//   filterKind: FilterKind | undefined,
//   tab: TabKind
// ): ArSpaceExtended[] {
//   if (filterKind === 'store') return list.filter((i) => i.ar_type === 'branch');
//   if (filterKind === 'kol') return list.filter((i) => i.ar_type === 'ar_space');
//   if (tab !== 'all') return list.filter((i) => i.ar_type === tab);
//   return list;
// }

// function applyGroupFilter(
//   list: ArSpaceExtended[],
//   groupId: string,
//   arspaceGroups: ArSpaceGroup[]
// ): ArSpaceExtended[] {
//   if (groupId === 'all') return list;

//   const selectedGroup = arspaceGroups.find((g) => String(g.id) === groupId);
//   if (!selectedGroup || selectedGroup.data.length === 0) return list;

//   const allowedStoreIds = new Set<number>(selectedGroup.data);

//   return list.filter((item) => {
//     const storeId = item.store_id;
//     if (storeId == null) return false;
//     const num = typeof storeId === 'number' ? storeId : Number(storeId);
//     if (Number.isNaN(num)) return false;
//     return allowedStoreIds.has(num);
//   });
// }

// function parseLatLng(latitude?: string, longitude?: string): LatLng | null {
//   if (!latitude || !longitude) return null;
//   const lat = Number(latitude);
//   const lng = Number(longitude);
//   if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
//   if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
//   return { lat, lng };
// }

// function haversineMeters(a: LatLng, b: LatLng): number {
//   const R = 6371000;
//   const toRad = (deg: number) => (deg * Math.PI) / 180;

//   const dLat = toRad(b.lat - a.lat);
//   const dLng = toRad(b.lng - a.lng);

//   const lat1 = toRad(a.lat);
//   const lat2 = toRad(b.lat);

//   const sinDLat = Math.sin(dLat / 2);
//   const sinDLng = Math.sin(dLng / 2);

//   const h = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * (sinDLng * sinDLng);
//   return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
// }

// function getDistanceMeters(user: LatLng, item: ArSpaceExtended): number | null {
//   const pos = parseLatLng(item.latitude, item.longitude);
//   if (!pos) return null;
//   return haversineMeters(user, pos);
// }

// function toLatLng(p: GeoLatLng | null): LatLng | null {
//   if (!p) return null;
//   return { lat: p.lat, lng: p.lng };
// }

// const ArSpaceList: React.FC<Props> = ({
//   filterKind,
//   filterId,
//   listClassName,
//   filters,
//   enableGroups = true,
//   groups,
// }) => {
//   // ✅ runtime 強制：store 一律 branch；kol 一律 ar_space
//   const rawTab: TabKind = filters?.tab ?? 'all';
//   const tab: TabKind =
//     filterKind === 'store' ? 'branch' : filterKind === 'kol' ? 'ar_space' : rawTab;

//   const keyword: string = filters?.keyword ?? '';
//   const orderBy: OrderBy = filters?.orderBy ?? 'crtime';
//   const groupId: string = filters?.groupId ?? 'all';

//   const [resetKind, setResetKind] = useState<ResetKind>('other');

//   // debounce keyword（只影響 fetch / highlight）
//   const [debouncedKeyword, setDebouncedKeyword] = useState('');
//   const debouncedKeywordRef = useRef<string>('');
//   useEffect(() => {
//     const next = keyword.trim();
//     const timer = window.setTimeout(() => {
//       if (debouncedKeywordRef.current === next) return;
//       debouncedKeywordRef.current = next;
//       setDebouncedKeyword(next);
//       setResetKind('keyword');
//     }, 350);
//     return () => window.clearTimeout(timer);
//   }, [keyword]);

//   const highlightText = useCallback(
//     (text: string): React.ReactNode => {
//       if (!debouncedKeyword) return text;
//       const safe = escapeRegExp(debouncedKeyword);
//       const parts = text.split(new RegExp(`(${safe})`, 'gi'));
//       return parts.map((part, i) =>
//         part.toLowerCase() === debouncedKeyword.toLowerCase() ? (
//           <mark key={i} className="fw-bold" style={{ backgroundColor: '#fff2f2' }}>
//             {part}
//           </mark>
//         ) : (
//           part
//         )
//       );
//     },
//     [debouncedKeyword]
//   );

//   // =========================
//   // ✅ distance：定位（含快取）
//   // =========================
//   const [userPos, setUserPos] = useState<LatLng | null>(() => {
//     const cached = toLatLng(
//       readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//     );
//     return cached;
//   });
//   const [locStatus, setLocStatus] = useState<LocationStatus>(() => (userPos ? 'ready' : 'idle'));
//   const [distanceReadyToken, setDistanceReadyToken] = useState(0);

//   const locRequestIdRef = useRef(0);

//   const startLocationRequest = useCallback(() => {
//     // 先用快取救回
//     const cached = toLatLng(
//       readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//     );
//     if (!userPos && cached) {
//       setUserPos(cached);
//       setLocStatus('ready');
//       setResetKind('order');
//       setDistanceReadyToken((v) => v + 1);
//       return;
//     }

//     if (userPos) {
//       setLocStatus('ready');
//       return;
//     }

//     if (locStatus === 'pending') return;
//     setLocStatus('pending');

//     const rid = ++locRequestIdRef.current;

//     void (async () => {
//       const res = await getCurrentPositionSafe(
//         { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
//         12000
//       );
//       if (locRequestIdRef.current !== rid) return;

//       if (!res.ok) {
//         if (res.reason === 'unavailable') setLocStatus('unavailable');
//         else if (res.reason === 'denied') setLocStatus('denied');
//         else setLocStatus('error');
//         return;
//       }

//       const next = { lat: res.pos.lat, lng: res.pos.lng };
//       setUserPos(next);
//       setLocStatus('ready');

//       writeCachedPosition(next, { key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' });

//       setResetKind('order');
//       setDistanceReadyToken((v) => v + 1);
//     })();
//   }, [locStatus, userPos]);

//   // distance 模式：只要求定位，不先載 crtime
//   useEffect(() => {
//     if (orderBy !== 'distance') return;
//     if (userPos) return;
//     if (locStatus === 'idle') startLocationRequest();
//   }, [orderBy, userPos, locStatus, startLocationRequest]);

//   // ✅ 關鍵修正：回到頁面（上一頁）時，distance 一律觸發 reset（避免 route cache/bfcache 還原舊狀態）
//   const orderByRef = useRef(orderBy);
//   useEffect(() => {
//     orderByRef.current = orderBy;
//   }, [orderBy]);

//   const [resumeToken, setResumeToken] = useState(0);

//   useEffect(() => {
//     if (typeof window === 'undefined') return;

//     const bumpIfDistance = () => {
//       if (orderByRef.current !== 'distance') return;

//       // 回來時再讀一次快取，避免 userPos 在某些還原情境為 null
//       const cached = toLatLng(
//         readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
//       );
//       if (!userPos && cached) {
//         setUserPos(cached);
//         setLocStatus('ready');
//         setDistanceReadyToken((v) => v + 1);
//       } else if (!userPos && locStatus === 'idle') {
//         startLocationRequest();
//       }

//       // 強制讓 resetKey 變動，讓 InfiniteList 重新抓 distance
//       setResetKind('order');
//       setResumeToken((v) => v + 1);
//     };

//     const onPageShow = () => bumpIfDistance();
//     const onFocus = () => bumpIfDistance();
//     const onVis = () => {
//       if (document.visibilityState === 'visible') bumpIfDistance();
//     };

//     window.addEventListener('pageshow', onPageShow);
//     window.addEventListener('focus', onFocus);
//     document.addEventListener('visibilitychange', onVis);

//     return () => {
//       window.removeEventListener('pageshow', onPageShow);
//       window.removeEventListener('focus', onFocus);
//       document.removeEventListener('visibilitychange', onVis);
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [locStatus, startLocationRequest, userPos]);

//   // =========================
//   // groups
//   // =========================
//   const [internalGroups, setInternalGroups] = useState<ArSpaceGroup[]>([]);
//   const arspaceGroups = groups ?? internalGroups;

//   useEffect(() => {
//     if (!enableGroups) return;
//     if (groups) return;

//     const run = async () => {
//       try {
//         const list = await ArSpaceService.getArSpaceGroup({ withAuth: false });
//         setInternalGroups(list);
//       } catch {
//         setInternalGroups([]);
//       }
//     };
//     void run();
//   }, [enableGroups, groups]);

//   // =========================
//   // modals
//   // =========================
//   const [scanOpen, setScanOpen] = useState(false);
//   const [scanPic, setScanPic] = useState<string | undefined>(undefined);
//   const [mapOpen, setMapOpen] = useState(false);
//   const [mapTitle, setMapTitle] = useState('');
//   const [mapQuery, setMapQuery] = useState('');

//   const openScan = useCallback((item: ArSpace) => {
//     setScanPic(item.cover);
//     setScanOpen(true);
//   }, []);

//   const openMap = useCallback((item: ArSpace) => {
//     const query = (item.address || '').trim() || (item.branch_name || '').trim() || item.title;
//     setMapTitle(item.branch_name);
//     setMapQuery(query);
//     setMapOpen(true);
//   }, []);

//   // hidden ids
//   const [hiddenIds, setHiddenIds] = useState<Set<string | number>>(() => new Set());
//   const handleDeleted = useCallback((deletedId: string | number) => {
//     setHiddenIds((prev) => {
//       if (prev.has(deletedId)) return prev;
//       const next = new Set(prev);
//       next.add(deletedId);
//       return next;
//     });
//   }, []);

//   // dedupe
//   const seenIdsRef = useRef<Set<string>>(new Set());

//   // page base
//   const pageBaseRef = useRef<0 | 1 | null>(null);

//   const fetchArSpace = useCallback(
//     async ({
//       page,
//       pageSize,
//     }: {
//       page: number;
//       pageSize?: number;
//     }): Promise<{ items: ArSpace[]; hasMore: boolean }> => {
//       const size = pageSize ?? PAGE_SIZE;

//       const rawPage = Number(page);
//       const safeRaw = Number.isFinite(rawPage) ? rawPage : 1;

//       if (pageBaseRef.current === null) {
//         pageBaseRef.current = safeRaw === 0 ? 0 : 1;
//       }

//       const pageParam = pageBaseRef.current === 0 ? Math.max(1, safeRaw + 1) : Math.max(1, safeRaw);

//       const arTypeParam = resolveArTypeParam(filterKind, tab);

//       // ✅ distance：沒有定位就不打 API
//       if (orderBy === 'distance' && !userPos) {
//         if (locStatus === 'idle') startLocationRequest();
//         return { items: [], hasMore: false };
//       }

//       const params: {
//         page: number;
//         keywords?: string;
//         ar_type?: ArType;
//         order_by: OrderBy;
//         latitude?: number;
//         longitude?: number;
//         store_id?: number | string;
//         owner_open_id?: number | string;
//       } = {
//         page: pageParam,
//         order_by: orderBy,
//       };

//       if (debouncedKeyword) params.keywords = debouncedKeyword;
//       if (arTypeParam) params.ar_type = arTypeParam;

//       if (orderBy === 'distance' && userPos) {
//         params.latitude = userPos.lat;
//         params.longitude = userPos.lng;
//       }

//       // ✅ store_id 建議傳 number（避免後端嚴格型別忽略）
//       if (filterKind === 'store' && filterId != null) {
//         const n = Number(filterId);
//         params.store_id = Number.isNaN(n) ? filterId : n;
//       }

//       if (filterKind === 'kol' && filterId != null) params.owner_open_id = String(filterId);

//       try {
//         const data = await ArSpaceService.list(params, { withAuth: false });
//         const list = (data.items ?? []) as ArSpaceExtended[];

//         let filtered = list;

//         // 先做 store/owner 篩選
//         filtered = applyOwnerOrStoreFilter(filtered, filterKind, filterId);

//         // ✅ 重要：store/kol 模式的 ar_type 已透過 API 參數控制（branch / ar_space）
//         // 避免因後端 items 缺少 ar_type 欄位而整頁被前端濾光，造成「要跑一陣子才有資料」
//         if (!filterKind) {
//           filtered = applyArTypeFilter(filtered, filterKind, tab);
//         }

//         if (enableGroups) filtered = applyGroupFilter(filtered, groupId, arspaceGroups);

//         const seen = seenIdsRef.current;
//         const deduped = filtered.filter((item) => {
//           const id = String(item.id ?? '');
//           if (!id) return true;
//           if (seen.has(id)) return false;
//           seen.add(id);
//           return true;
//         });

//         let finalItems: ArSpaceExtended[] = deduped;

//         // ✅ 前端 double-check distance 排序
//         if (orderBy === 'distance' && userPos) {
//           const withDist = finalItems.map((it) => ({ it, d: getDistanceMeters(userPos, it) }));
//           withDist.sort((a, b) => {
//             const da = a.d ?? Number.POSITIVE_INFINITY;
//             const db = b.d ?? Number.POSITIVE_INFINITY;
//             if (da !== db) return da - db;
//             return String(a.it.id).localeCompare(String(b.it.id));
//           });
//           finalItems = withDist.map((x) => x.it);
//         }

//         // ✅ 關鍵修正：hasMore 用後端 total/page_size 算，避免因 finalItems(前端濾完) 為 0 而提早停 / 或狂掃頁數
//         const backendPageNo = Number.isFinite(data.page) ? data.page : pageParam;
//         const backendPageSize =
//           Number.isFinite(data.page_size) && data.page_size > 0 ? data.page_size : size;

//         // 若 total 不可靠（例如偶爾上游回 array，你的 service 兼容會讓 total=items.length）
//         // 就 fallback 以「本頁是否滿 size」判斷，寧可多打一頁，也不要提早停
//         const hasReliableTotal =
//           Number.isFinite(data.total) && data.total >= 0 && data.total > backendPageSize;

//         const hasMore = hasReliableTotal
//           ? backendPageNo * backendPageSize < data.total
//           : list.length >= size;

//         return { items: finalItems, hasMore };
//       } catch {
//         return { items: [], hasMore: false };
//       }
//     },
//     [
//       arspaceGroups,
//       debouncedKeyword,
//       enableGroups,
//       filterId,
//       filterKind,
//       groupId,
//       locStatus,
//       orderBy,
//       startLocationRequest,
//       tab,
//       userPos,
//     ]
//   );

//   const resetKey = useMemo(() => {
//     const groupPart = enableGroups ? groupId : 'nogroup';
//     const distPart =
//       orderBy === 'distance'
//         ? userPos
//           ? `pos:${userPos.lat.toFixed(6)},${userPos.lng.toFixed(6)}|tok:${distanceReadyToken}|resume:${resumeToken}`
//           : `nopos:${locStatus}|tok:${distanceReadyToken}|resume:${resumeToken}`
//         : 'nodist';

//     return `${filterKind ?? 'all'}|${filterId ?? 'all'}|${tab}|${debouncedKeyword}|${orderBy}|${groupPart}|${distPart}`;
//   }, [
//     debouncedKeyword,
//     distanceReadyToken,
//     enableGroups,
//     filterId,
//     filterKind,
//     groupId,
//     locStatus,
//     orderBy,
//     resumeToken,
//     tab,
//     userPos,
//   ]);

//   useEffect(() => {
//     seenIdsRef.current = new Set();
//     pageBaseRef.current = null;
//   }, [resetKey]);

//   const renderCardSkeleton = useCallback(
//     (idx: number) => (
//       <div className="col" key={`sk-col-${idx}`}>
//         <div className="card h-100">
//           <div className="position-relative">
//             <Skeleton width="100%" height="160px" radius="0.375rem" />
//           </div>
//           <div className="card-body p-3">
//             <div className="d-flex align-items-center mb-2">
//               <Skeleton width="30px" height="30px" radius="50%" />
//               <Skeleton width="60px" height="12px" radius="4px" className="ms-2" />
//             </div>
//             <Skeleton width="80%" height="16px" radius="4px" />
//           </div>
//           <div className="card-footer">
//             <Skeleton width="70%" height="12px" radius="4px" />
//           </div>
//         </div>
//       </div>
//     ),
//     []
//   );

//   const emptyView = useMemo(() => {
//     if (orderBy === 'distance' && !userPos) {
//       if (locStatus === 'pending' || locStatus === 'idle') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             正在取得定位中…
//             <div className="small text-muted mt-2">若跳出權限提示請按「允許」</div>
//           </div>
//         );
//       }
//       if (locStatus === 'denied') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             距離排序需要定位權限
//             <div className="small text-muted mt-2">請在瀏覽器設定允許定位，或改用「依最新→舊」</div>
//           </div>
//         );
//       }
//       if (locStatus === 'unavailable') {
//         return (
//           <div className="text-grey text-center py-5 w-100">
//             <span className="d-block mb-3">
//               <ArSpaceOutlineIcon width={60} />
//             </span>
//             此裝置不支援定位
//             <div className="small text-muted mt-2">請改用「依最新→舊」</div>
//           </div>
//         );
//       }
//       return (
//         <div className="text-grey text-center py-5 w-100">
//           <span className="d-block mb-3">
//             <ArSpaceOutlineIcon width={60} />
//           </span>
//           取得定位失敗
//           <div className="small text-muted mt-2">請稍後再試或改用其他排序</div>
//           <button
//             type="button"
//             className="btn btn-outline-secondary btn-sm mt-3"
//             onClick={() => {
//               setLocStatus('idle');
//               startLocationRequest();
//             }}
//           >
//             重新嘗試定位
//           </button>
//         </div>
//       );
//     }

//     return <EmptyState {...buildEmptyState(EMPTY.arSpace.noPosts)} />;
//   }, [locStatus, orderBy, startLocationRequest, userPos]);

//   return (
//     <>
//       <InfiniteListWithFetch<ArSpace>
//         fetchData={fetchArSpace}
//         getKey={(item, idx) => `${(item as ArSpaceExtended).id}-${idx}`}
//         renderItem={(item) =>
//           hiddenIds.has(item.id) ? null : (
//             <ArSpaceCard
//               item={item}
//               onOpenScan={openScan}
//               onOpenMap={openMap}
//               highlight={highlightText}
//               onDeleted={handleDeleted}
//             />
//           )
//         }
//         resetKey={resetKey}
//         resetKind={resetKind}
//         className={listClassName ?? 'row row-cols-2 row-cols-md-3 row-cols-xl-4 g-4'}
//         renderSkeleton={renderCardSkeleton}
//         skeletonMode="matchLoadedOrPrev"
//         skeletonInitialCount={5}
//         rootMargin="200px"
//         emptyView={emptyView}
//         errorView={<div className="col-12 text-center py-4 text-danger">載入失敗，請稍後再試</div>}
//         bootingSkeletonModeMap={{
//           keyword: 'none',
//           tab: 'prevCount',
//           order: 'prevCount',
//           group: 'prevCount',
//           other: 'prevCount',
//         }}
//         pageSize={PAGE_SIZE}
//       />

//       <ArScanModal
//         open={scanOpen}
//         onClose={() => setScanOpen(false)}
//         scanPic={scanPic}
//         onScan={() => {
//           console.log('Start scanning…');
//           setScanOpen(false);
//         }}
//       />

//       <MapModal
//         open={mapOpen}
//         title={mapTitle}
//         query={mapQuery}
//         onClose={() => setMapOpen(false)}
//       />
//     </>
//   );
// };

// export default ArSpaceList;

// src/components/page/ar-space/ArSpaceList.tsx
'use client';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

// components
import InfiniteListWithFetch from '@/components/ui/list/InfiniteListWithFetch';
import Skeleton from '@/components/ui/skeleton/Skeleton';
import ArScanModal from '@/components/ui/modal/ArScanModal';
import MapModal from '@/components/ui/modal/MapModal';
import ArSpaceCard from '@/components/page/ar-space/ArSpaceCard';
import { EmptyState, EMPTY, buildEmptyState } from '@/components/ui/emptyState';

// data
import type { ArSpace, ArType, ArSpaceGroup, OrderBy } from '@/types/arSpace';
import { ArSpaceService } from '@/libs/services/arSpace';

import ArSpaceOutlineIcon from '@/components/icons/ArSpaceOutlineIcon';

// ✅ 共用定位快取工具
import {
  readCachedPosition,
  writeCachedPosition,
  getCurrentPositionSafe,
  type LatLng as GeoLatLng,
} from '@/libs/location/geoCache';

// ✅ 後端文件：一頁 20 筆（前端 pageSize 也用 20 最穩）
const PAGE_SIZE = 20;

type FilterKind = 'kol' | 'store';
type TabKind = 'all' | ArType;
type LatLng = { lat: number; lng: number };
type ResetKind = 'keyword' | 'tab' | 'order' | 'group' | 'other';

type LocationStatus = 'idle' | 'pending' | 'ready' | 'denied' | 'unavailable' | 'error';

const GEO_CACHE_KEY = 'arspace_user_pos_v1';
const GEO_CACHE_TTL = 30 * 60 * 1000; // 30 min

type ArSpaceExtended = ArSpace & {
  ar_type?: ArType | string;
  store_id?: number | string;
  storeId?: number | string;
  owner_open_id?: string;
  ownerOpenId?: string;
};

export type ArSpaceListFilters = {
  tab: TabKind;
  keyword: string;
  orderBy: OrderBy;
  groupId: string;
};

type Props = {
  filterKind?: FilterKind;
  filterId?: number | string;
  listClassName?: string;

  filters?: Partial<ArSpaceListFilters>;
  onFiltersChange?: (next: ArSpaceListFilters) => void;

  enableGroups?: boolean;
  groups?: ArSpaceGroup[];
};

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

function resolveArTypeParam(filterKind: FilterKind | undefined, tab: TabKind): '' | ArType {
  if (filterKind === 'store') return 'branch';
  if (filterKind === 'kol') return 'ar_space';
  return tab === 'branch' ? 'branch' : tab === 'ar_space' ? 'ar_space' : '';
}

function applyOwnerOrStoreFilter(
  list: ArSpaceExtended[],
  filterKind: FilterKind | undefined,
  filterId: number | string | undefined
): ArSpaceExtended[] {
  if (!filterKind || filterId == null) return list;

  if (filterKind === 'store') {
    const targetStr = String(filterId);
    const targetNum = Number(filterId);
    return list.filter((item) => {
      const raw = item.store_id;
      const norm = item.storeId;
      return (
        (raw != null && String(raw) === targetStr) || (norm != null && Number(norm) === targetNum)
      );
    });
  }

  if (filterKind === 'kol') {
    const target = String(filterId);
    return list.filter((item) => {
      const raw = item.owner_open_id;
      const norm = item.ownerOpenId;
      return (raw != null && String(raw) === target) || (norm != null && String(norm) === target);
    });
  }

  return list;
}

function applyArTypeFilter(
  list: ArSpaceExtended[],
  filterKind: FilterKind | undefined,
  tab: TabKind
): ArSpaceExtended[] {
  if (filterKind === 'store') return list.filter((i) => i.ar_type === 'branch');
  if (filterKind === 'kol') return list.filter((i) => i.ar_type === 'ar_space');
  if (tab !== 'all') return list.filter((i) => i.ar_type === tab);
  return list;
}

function applyGroupFilter(
  list: ArSpaceExtended[],
  groupId: string,
  arspaceGroups: ArSpaceGroup[]
): ArSpaceExtended[] {
  if (groupId === 'all') return list;

  const selectedGroup = arspaceGroups.find((g) => String(g.id) === groupId);
  if (!selectedGroup || selectedGroup.data.length === 0) return list;

  const allowedStoreIds = new Set<number>(selectedGroup.data);

  return list.filter((item) => {
    const storeId = item.store_id;
    if (storeId == null) return false;
    const num = typeof storeId === 'number' ? storeId : Number(storeId);
    if (Number.isNaN(num)) return false;
    return allowedStoreIds.has(num);
  });
}

function parseLatLng(latitude?: string, longitude?: string): LatLng | null {
  if (!latitude || !longitude) return null;
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

function haversineMeters(a: LatLng, b: LatLng): number {
  const R = 6371000;
  const toRad = (deg: number) => (deg * Math.PI) / 180;

  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);

  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);

  const sinDLat = Math.sin(dLat / 2);
  const sinDLng = Math.sin(dLng / 2);

  const h = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * (sinDLng * sinDLng);
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
}

function getDistanceMeters(user: LatLng, item: ArSpaceExtended): number | null {
  const pos = parseLatLng(item.latitude, item.longitude);
  if (!pos) return null;
  return haversineMeters(user, pos);
}

function toLatLng(p: GeoLatLng | null): LatLng | null {
  if (!p) return null;
  return { lat: p.lat, lng: p.lng };
}

const ArSpaceList: React.FC<Props> = ({
  filterKind,
  filterId,
  listClassName,
  filters,
  enableGroups = true,
  groups,
}) => {
  const tab: TabKind = filters?.tab ?? 'all';
  const keyword: string = filters?.keyword ?? '';

  // ✅ 這裡原本就 letime 預設，保留
  const orderBy: OrderBy = filters?.orderBy ?? 'letime';

  const groupId: string = filters?.groupId ?? 'all';

  const [resetKind, setResetKind] = useState<ResetKind>('other');

  // ✅ 補：tab / order / group 變動時，讓 resetKind 對應正確（避免看起來像沒刷新）
  const prevTabRef = useRef(tab);
  useEffect(() => {
    if (prevTabRef.current !== tab) {
      prevTabRef.current = tab;
      setResetKind('tab');
    }
  }, [tab]);

  const prevOrderRef = useRef(orderBy);
  useEffect(() => {
    if (prevOrderRef.current !== orderBy) {
      prevOrderRef.current = orderBy;
      setResetKind('order');
    }
  }, [orderBy]);

  const prevGroupRef = useRef(groupId);
  useEffect(() => {
    if (prevGroupRef.current !== groupId) {
      prevGroupRef.current = groupId;
      setResetKind('group');
    }
  }, [groupId]);

  // debounce keyword（只影響 fetch / highlight）
  const [debouncedKeyword, setDebouncedKeyword] = useState('');
  const debouncedKeywordRef = useRef<string>('');
  useEffect(() => {
    const next = keyword.trim();
    const timer = window.setTimeout(() => {
      if (debouncedKeywordRef.current === next) return;
      debouncedKeywordRef.current = next;
      setDebouncedKeyword(next);
      setResetKind('keyword');
    }, 350);
    return () => window.clearTimeout(timer);
  }, [keyword]);

  const highlightText = useCallback(
    (text: string): React.ReactNode => {
      if (!debouncedKeyword) return text;
      const safe = escapeRegExp(debouncedKeyword);
      const parts = text.split(new RegExp(`(${safe})`, 'gi'));
      return parts.map((part, i) =>
        part.toLowerCase() === debouncedKeyword.toLowerCase() ? (
          <mark key={i} className="fw-bold" style={{ backgroundColor: '#fff2f2' }}>
            {part}
          </mark>
        ) : (
          part
        )
      );
    },
    [debouncedKeyword]
  );

  // =========================
  // ✅ distance：定位（含快取）
  // =========================
  const [userPos, setUserPos] = useState<LatLng | null>(() => {
    const cached = toLatLng(
      readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
    );
    return cached;
  });
  const [locStatus, setLocStatus] = useState<LocationStatus>(() => (userPos ? 'ready' : 'idle'));
  const [distanceReadyToken, setDistanceReadyToken] = useState(0);

  const locRequestIdRef = useRef(0);

  const startLocationRequest = useCallback(() => {
    const cached = toLatLng(
      readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
    );
    if (!userPos && cached) {
      setUserPos(cached);
      setLocStatus('ready');
      setResetKind('order');
      setDistanceReadyToken((v) => v + 1);
      return;
    }

    if (userPos) {
      setLocStatus('ready');
      return;
    }

    if (locStatus === 'pending') return;
    setLocStatus('pending');

    const rid = ++locRequestIdRef.current;

    void (async () => {
      const res = await getCurrentPositionSafe(
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
        12000
      );
      if (locRequestIdRef.current !== rid) return;

      if (!res.ok) {
        if (res.reason === 'unavailable') setLocStatus('unavailable');
        else if (res.reason === 'denied') setLocStatus('denied');
        else setLocStatus('error');
        return;
      }

      const next = { lat: res.pos.lat, lng: res.pos.lng };
      setUserPos(next);
      setLocStatus('ready');

      writeCachedPosition(next, { key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' });

      setResetKind('order');
      setDistanceReadyToken((v) => v + 1);
    })();
  }, [locStatus, userPos]);

  useEffect(() => {
    if (orderBy !== 'distance') return;
    if (userPos) return;
    if (locStatus === 'idle') startLocationRequest();
  }, [orderBy, userPos, locStatus, startLocationRequest]);

  const orderByRef = useRef(orderBy);
  useEffect(() => {
    orderByRef.current = orderBy;
  }, [orderBy]);

  const [resumeToken, setResumeToken] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const bumpIfDistance = () => {
      if (orderByRef.current !== 'distance') return;

      const cached = toLatLng(
        readCachedPosition({ key: GEO_CACHE_KEY, ttlMs: GEO_CACHE_TTL, storage: 'session' })
      );
      if (!userPos && cached) {
        setUserPos(cached);
        setLocStatus('ready');
        setDistanceReadyToken((v) => v + 1);
      } else if (!userPos && locStatus === 'idle') {
        startLocationRequest();
      }

      setResetKind('order');
      setResumeToken((v) => v + 1);
    };

    const onPageShow = () => bumpIfDistance();
    const onFocus = () => bumpIfDistance();
    const onVis = () => {
      if (document.visibilityState === 'visible') bumpIfDistance();
    };

    window.addEventListener('pageshow', onPageShow);
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVis);

    return () => {
      window.removeEventListener('pageshow', onPageShow);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVis);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locStatus, startLocationRequest, userPos]);

  // =========================
  // groups
  // =========================
  const [internalGroups, setInternalGroups] = useState<ArSpaceGroup[]>([]);
  const arspaceGroups = groups ?? internalGroups;

  useEffect(() => {
    if (!enableGroups) return;
    if (groups) return;

    const run = async () => {
      try {
        const list = await ArSpaceService.getArSpaceGroup({ withAuth: false });
        setInternalGroups(list);
      } catch {
        setInternalGroups([]);
      }
    };
    void run();
  }, [enableGroups, groups]);

  // =========================
  // modals
  // =========================
  const [scanOpen, setScanOpen] = useState(false);
  const [scanPic, setScanPic] = useState<string | undefined>(undefined);
  const [mapOpen, setMapOpen] = useState(false);
  const [mapTitle, setMapTitle] = useState('');
  const [mapQuery, setMapQuery] = useState('');

  const openScan = useCallback((item: ArSpace) => {
    setScanPic(item.cover);
    setScanOpen(true);
  }, []);

  const openMap = useCallback((item: ArSpace) => {
    const query = (item.address || '').trim() || (item.branch_name || '').trim() || item.title;
    setMapTitle(item.branch_name);
    setMapQuery(query);
    setMapOpen(true);
  }, []);

  // hidden ids
  const [hiddenIds, setHiddenIds] = useState<Set<string | number>>(() => new Set());
  const handleDeleted = useCallback((deletedId: string | number) => {
    setHiddenIds((prev) => {
      if (prev.has(deletedId)) return prev;
      const next = new Set(prev);
      next.add(deletedId);
      return next;
    });
  }, []);

  // dedupe
  const seenIdsRef = useRef<Set<string>>(new Set());

  // page base
  const pageBaseRef = useRef<0 | 1 | null>(null);

  const fetchArSpace = useCallback(
    async ({
      page,
      pageSize,
    }: {
      page: number;
      pageSize?: number;
    }): Promise<{ items: ArSpace[]; hasMore: boolean }> => {
      const size = pageSize ?? PAGE_SIZE;

      const rawPage = Number(page);
      const safeRaw = Number.isFinite(rawPage) ? rawPage : 1;

      if (pageBaseRef.current === null) {
        pageBaseRef.current = safeRaw === 0 ? 0 : 1;
      }

      const pageParam = pageBaseRef.current === 0 ? Math.max(1, safeRaw + 1) : Math.max(1, safeRaw);

      const arTypeParam = resolveArTypeParam(filterKind, tab);

      if (orderBy === 'distance' && !userPos) {
        if (locStatus === 'idle') startLocationRequest();
        return { items: [], hasMore: false };
      }

      const params: {
        page: number;
        keywords?: string;
        ar_type?: ArType;
        order_by: OrderBy;
        latitude?: number;
        longitude?: number;
        store_id?: number | string;
        owner_open_id?: number | string;
      } = {
        page: pageParam,
        order_by: orderBy,
      };

      if (debouncedKeyword) params.keywords = debouncedKeyword;
      if (arTypeParam) params.ar_type = arTypeParam;

      if (orderBy === 'distance' && userPos) {
        params.latitude = userPos.lat;
        params.longitude = userPos.lng;
      }

      if (filterKind === 'store' && filterId != null) params.store_id = filterId;
      if (filterKind === 'kol' && filterId != null) params.owner_open_id = String(filterId);

      try {
        const data = await ArSpaceService.list(params, { withAuth: false });
        const list = (data.items ?? []) as ArSpaceExtended[];

        let filtered = list;
        filtered = applyOwnerOrStoreFilter(filtered, filterKind, filterId);
        filtered = applyArTypeFilter(filtered, filterKind, tab);

        if (enableGroups) filtered = applyGroupFilter(filtered, groupId, arspaceGroups);

        const seen = seenIdsRef.current;
        const deduped = filtered.filter((item) => {
          const id = String(item.id ?? '');
          if (!id) return true;
          if (seen.has(id)) return false;
          seen.add(id);
          return true;
        });

        let finalItems: ArSpaceExtended[] = deduped;

        if (orderBy === 'distance' && userPos) {
          const withDist = finalItems.map((it) => ({ it, d: getDistanceMeters(userPos, it) }));
          withDist.sort((a, b) => {
            const da = a.d ?? Number.POSITIVE_INFINITY;
            const db = b.d ?? Number.POSITIVE_INFINITY;
            if (da !== db) return da - db;
            return String(a.it.id).localeCompare(String(b.it.id));
          });
          finalItems = withDist.map((x) => x.it);
        }

        let hasMore = false;
        if (list.length < size) hasMore = false;
        else if (finalItems.length === 0 && pageParam > 1) hasMore = false;
        else hasMore = true;

        return { items: finalItems, hasMore };
      } catch {
        return { items: [], hasMore: false };
      }
    },
    [
      arspaceGroups,
      debouncedKeyword,
      enableGroups,
      filterId,
      filterKind,
      groupId,
      locStatus,
      orderBy,
      startLocationRequest,
      tab,
      userPos,
    ]
  );

  const resetKey = useMemo(() => {
    const groupPart = enableGroups ? groupId : 'nogroup';
    const distPart =
      orderBy === 'distance'
        ? userPos
          ? `pos:${userPos.lat.toFixed(6)},${userPos.lng.toFixed(6)}|tok:${distanceReadyToken}|resume:${resumeToken}`
          : `nopos:${locStatus}|tok:${distanceReadyToken}|resume:${resumeToken}`
        : 'nodist';

    return `${filterKind ?? 'all'}|${filterId ?? 'all'}|${tab}|${debouncedKeyword}|${orderBy}|${groupPart}|${distPart}`;
  }, [
    debouncedKeyword,
    distanceReadyToken,
    enableGroups,
    filterId,
    filterKind,
    groupId,
    locStatus,
    orderBy,
    resumeToken,
    tab,
    userPos,
  ]);

  useEffect(() => {
    seenIdsRef.current = new Set();
    pageBaseRef.current = null;
  }, [resetKey]);

  const renderCardSkeleton = useCallback(
    (idx: number) => (
      <div className="col" key={`sk-col-${idx}`}>
        <div className="card h-100">
          <div className="position-relative">
            <Skeleton width="100%" height="160px" radius="0.375rem" />
          </div>
          <div className="card-body p-3">
            <div className="d-flex align-items-center mb-2">
              <Skeleton width="30px" height="30px" radius="50%" />
              <Skeleton width="60px" height="12px" radius="4px" className="ms-2" />
            </div>
            <Skeleton width="80%" height="16px" radius="4px" />
          </div>
          <div className="card-footer">
            <Skeleton width="70%" height="12px" radius="4px" />
          </div>
        </div>
      </div>
    ),
    []
  );

  const emptyView = useMemo(() => {
    if (orderBy === 'distance' && !userPos) {
      if (locStatus === 'pending' || locStatus === 'idle') {
        return (
          <div className="text-grey text-center py-5 w-100">
            <span className="d-block mb-3">
              <ArSpaceOutlineIcon width={60} />
            </span>
            正在取得定位中…
            <div className="small text-muted mt-2">若跳出權限提示請按「允許」</div>
          </div>
        );
      }
      if (locStatus === 'denied') {
        return (
          <div className="text-grey text-center py-5 w-100">
            <span className="d-block mb-3">
              <ArSpaceOutlineIcon width={60} />
            </span>
            距離排序需要定位權限
            <div className="small text-muted mt-2">
              請在瀏覽器設定允許定位，或改用「建立時間新→舊」
            </div>
          </div>
        );
      }
      if (locStatus === 'unavailable') {
        return (
          <div className="text-grey text-center py-5 w-100">
            <span className="d-block mb-3">
              <ArSpaceOutlineIcon width={60} />
            </span>
            此裝置不支援定位
            <div className="small text-muted mt-2">請改用「建立時間新→舊」</div>
          </div>
        );
      }
      return (
        <div className="text-grey text-center py-5 w-100">
          <span className="d-block mb-3">
            <ArSpaceOutlineIcon width={60} />
          </span>
          取得定位失敗
          <div className="small text-muted mt-2">請稍後再試或改用其他排序</div>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm mt-3"
            onClick={() => {
              setLocStatus('idle');
              startLocationRequest();
            }}
          >
            重新嘗試定位
          </button>
        </div>
      );
    }

    return <EmptyState {...buildEmptyState(EMPTY.arSpace.noPosts)} />;
  }, [locStatus, orderBy, startLocationRequest, userPos]);

  return (
    <>
      <InfiniteListWithFetch<ArSpace>
        fetchData={fetchArSpace}
        getKey={(item, idx) => `${(item as ArSpaceExtended).id}-${idx}`}
        renderItem={(item) =>
          hiddenIds.has(item.id) ? null : (
            <ArSpaceCard
              item={item}
              onOpenScan={openScan}
              onOpenMap={openMap}
              highlight={highlightText}
              onDeleted={handleDeleted}
            />
          )
        }
        resetKey={resetKey}
        resetKind={resetKind}
        className={listClassName ?? 'row row-cols-2 row-cols-md-3 row-cols-xl-4 g-4'}
        renderSkeleton={renderCardSkeleton}
        skeletonMode="matchLoadedOrPrev"
        skeletonInitialCount={5}
        rootMargin="200px"
        emptyView={emptyView}
        errorView={<div className="col-12 text-center py-4 text-danger">載入失敗，請稍後再試</div>}
        bootingSkeletonModeMap={{
          keyword: 'none',
          tab: 'prevCount',
          order: 'prevCount',
          group: 'prevCount',
          other: 'prevCount',
        }}
        pageSize={PAGE_SIZE}
      />

      <ArScanModal
        open={scanOpen}
        onClose={() => setScanOpen(false)}
        scanPic={scanPic}
        onScan={() => {
          console.log('Start scanning…');
          setScanOpen(false);
        }}
      />

      <MapModal
        open={mapOpen}
        title={mapTitle}
        query={mapQuery}
        onClose={() => setMapOpen(false)}
      />
    </>
  );
};

export default ArSpaceList;
